import React from 'react';
import { observer } from 'mobx-react';
import { IntlShape } from 'react-intl';
import MeetingFormVM from '../meeting-form.viewmodel';
import Text from '../../../../../global/text/text';

import './on-meeting-date-changed-modal.scss';

interface IOnMeetingDateChangedModalProps {
    intl: IntlShape;
    vm: MeetingFormVM;
}

const OnMeetingDateChangedModal = observer(({
    vm,
    intl,
}: IOnMeetingDateChangedModalProps) => {

    return (
        <>
            <div className='m-bottom-14px'>
                {
                    intl.formatMessage({
                        id: 'oe.messages.youHaveEditedTheTimeofAMeeting',
                        description: 'Text',
                        defaultMessage: 'You have edited the time of a meeting which has Zoom Connections:'
                    })
                }
            </div>
            {
                vm.meetingsAndWebinarsList.map(c => (
                    <div
                        key={c.meetingConnectionId}
                    >
                        <Text message={c.type} />: { c.connectionId }
                    </div>
                ))
            }
            <div className='m-top-14px m-bottom-14px'>
                {
                    intl.formatMessage({
                        id: 'oe.messages.youShouldNow',
                        description: 'Text',
                        defaultMessage: 'You should now '
                    })
                }
                <span className='error-text'>
                    {
                        intl.formatMessage({
                            id: 'oe.messages.youShouldNow',
                            description: 'Text',
                            defaultMessage: 'update these connections '
                        })
                    }
                </span>
                {
                    intl.formatMessage({
                        id: 'oe.messages.correctMeetingTimesStoredInZoom',
                        description: 'Text',
                        defaultMessage: 'so that the correct meeting times are stored in Zoom.'
                    })
                }
            </div>
            <div>
                {
                    intl.formatMessage({
                        id: 'oe.messages.correctMeetingTimesStoredInZoom',
                        description: 'Text',
                        defaultMessage: 'If you do not update the Connections, double-bookings may be created which will seriously impact delivery of both meetings.'
                    })
                }
            </div>
        </>
    );
});

export default OnMeetingDateChangedModal;